import React from 'react'
import { MY_CITATION_PROJECT_LIST_TITLE } from '@chegg-wt/core/constants/citations'
import { PageHeader } from '../../Layouts/styled'
import * as Styled from './styled'
import ProjectSearchBar from './ProjectSearchBar'

export const FoldersTop: React.FC = () => (
  <PageHeader>{MY_CITATION_PROJECT_LIST_TITLE}</PageHeader>
)

const Header: React.FC = () => (
  <Styled.Header>
    <Styled.HeaderContainer>
      <Styled.ListSelector />
      <ProjectSearchBar />
    </Styled.HeaderContainer>
  </Styled.Header>
)

export default Header
